import GameState from "slotworks/model/game-state";
import GambleInitRecord from "slotworks/model/gameplay/records/gamble-init-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class ShouldStartGamble extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        return (record instanceof GambleInitRecord) ? Exit.True : Exit.False;
    }
}
